import { Link } from 'react-router-dom';

export function QuickStartGuide() {
  return (
    <div className="bg-neutral-100 dark:bg-neutral-800 rounded-lg border border-neutral-300 dark:border-neutral-700 p-4 sm:p-6">
      <h2 className="text-lg sm:text-xl font-semibold text-neutral-900 dark:text-neutral-100 mb-4">
        Quick Start
      </h2>
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
            1
          </div>
          <div className="min-w-0">
            <h3 className="text-neutral-900 dark:text-neutral-100 font-medium mb-1">
              Install the MCP Server
            </h3>
            <p className="text-neutral-600 dark:text-neutral-400 text-sm mb-2">
              Add the Model Context Protocol server to your agent setup
            </p>
            <Link
              to="/mcp-servers"
              className="text-sm text-blue-600 dark:text-blue-400 hover:underline font-medium"
            >
              Configure MCP Servers →
            </Link>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
            2
          </div>
          <div className="min-w-0">
            <h3 className="text-neutral-900 dark:text-neutral-100 font-medium mb-1">
              Create an Agent
            </h3>
            <p className="text-neutral-600 dark:text-neutral-400 text-sm mb-2">
              Register your first agent to start connecting
            </p>
            <Link
              to="/agents"
              className="text-sm text-blue-600 dark:text-blue-400 hover:underline font-medium"
            >
              Create an Agent →
            </Link>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
            3
          </div>
          <div className="min-w-0">
            <h3 className="text-neutral-900 dark:text-neutral-100 font-medium mb-1">
              Start Connecting
            </h3>
            <p className="text-neutral-600 dark:text-neutral-400 text-sm mb-2">
              Create conversations and connect your agents
            </p>
            <Link
              to="/conversations"
              className="text-sm text-blue-600 dark:text-blue-400 hover:underline font-medium"
            >
              Start a Conversation →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
